<template>
    <div class="login" @keyup="keyUp($event)">
        <ul>
            <li class='phone' :class="getPhone">
                <input type="text" autocomplete="off" v-model='loginForm.phone' placeholder="请输入手机号码">
                <span>{{ msgphone }}</span>
            </li>
            <li class='pwd' :class="getPassword">
                <!--<input  AUTOCOMPLETE="off" type="text" v-if="false">-->
                <input type="text" onFocus="this.type='password'" autocomplete="new-password"
                       v-model='loginForm.password'
                       placeholder="请输入您的密码">
                <span>{{ mespass }}</span>
            </li>
        </ul>
        <div class="forget">
            <router-link to="/resetPwd">忘记密码</router-link>
            <!--<label>-->
            <!--&lt;!&ndash;<input name="Fruit" type="checkbox" value="" @click='change()'/>&ndash;&gt;-->
            <!--<a target="_blank" href="http://admin.asjlx.com/agent/login/login">经纪人登录</a> </label>-->
        </div>
        <button type='button' class="btn" :class="getClass" @click="submitForm()">立即登录</button>
    </div>
</template>

<script type="text/ecmascript-6">
	import {login} from "../../api/index";
	import {meInfo} from "../../apiNew/index";

	export default {
		data() {
			return {
				loginForm: {
					phone: '',
					password: '',
				},
				msgphone: '',
				mespass: '',
				state: false,
				source: '',// 0 注册返回
			}
		},
		created() {
			window.addEventListener('setItem', () => {
				// console.log(localStorage.getItem('loginSource'))
				this.source = localStorage.getItem('loginSource')

			})
		},
		methods: {
			keyUp(event) {
				// console.log(event.keyCode)
				if (event.keyCode == 13) {
					// 调用登录按钮或者登录方法
					this.submitForm()
				}
			},
			// 表单提交
			submitForm() {
				let regTel = /^\d{11}$/g;
				if (this.loginForm.phone === "") {
					this.msgphone = '请输入手机号!'
				} else if (!regTel.test(this.loginForm.phone)) {
					this.msgphone = ('请输入11位手机号')
				} else if (this.loginForm.password === "") {
					this.mespass = '请输入密码!'
				} else {
					login(
						this.loginForm
					).then(res => {
						console.log(res)
						if (res.code === 0) {
							localStorage.setItem('token', res.data.token)
							meInfo({
								token: res.data.token
							}).then(ress => {
								console.log(ress)
								if (ress.code === 0) {
									// this.$addLocalStorageEvent('isLogin','1')
									localStorage.setItem('isLogin', '1');
									localStorage.setItem('userInfo', JSON.stringify(ress.data));
								}
							}).catch(err => {
								// this.$addLocalStorageEvent('isLogin','0')
								localStorage.setItem('isLogin', '0');
								// console.log(err)
								this.$message({
									message: err.message,
									type: 'warning'
								})
							})
							if (this.source === '0') {
								this.$router.push("/home");
							} else {
								this.$router.go(-1)
							}
						}
						if (res.code === -1) {
							if (res.msg === '手机号未注册') {
								this.$message({
									message: res.msg + '请先注册',
									type: 'warning'
								});
								this.$addStorageEvent("login_type", 1);
								this.$router.push({path: '/login'})
							} else {
								this.$message({
									message: res.msg,
									type: 'warning'
								});
							}
						}
					}).catch(err => {
						console.log(err);
					})
				}
			},
		},
		computed: {
			getClass() {
				if (this.loginForm.phone === '' || this.loginForm.password === '') {
					return
				} else {
					return 'successColor1'
				}
			},
			//去除提示
			getPhone() {
				var that = this
				if (this.loginForm.phone !== '') {
					return that.msgphone = ''
				}
			},
			getPassword() {
				var that = this
				if (this.loginForm.password !== '') {
					return that.mespass = ''
				}
			},
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
    .login {
        padding-top: 20px;
        ul {
            padding-top: 20px;
            li {
                position: relative;
                margin-bottom: 20px;
                input {
                    width: 100%;
                    padding: 10px 0;
                    border: none;
                    border-bottom: 1px solid #ccc;
                    outline: none;
                }
                span {
                    position: absolute;
                    top: 100%;
                    left: 0;
                    font-size: 14px;
                    color: #FF5E5E;
                }

                button {
                    position: absolute;
                    right: 0;
                    bottom: 8px;
                    width: 120px;
                    height: 40px;
                    font-size: 14px;
                    color: rgba(255, 255, 255, 1);
                    background: rgba(255, 174, 1, 1);
                    border: none;
                    border-radius: 2px;
                    outline: none;
                    cursor: pointer;
                }
            }
        }
        .forget {
            display: flex;
            align-items: center;
            justify-content: space-between;
            a {
                color: #50B3FF;
                font-size: 14px;

            }
            label {
                display: flex;
                align-items: center;
                cursor: pointer;
                color: #50B3FF;
                input {
                    margin-right: 5px;
                }
            }
        }
        button {
            width: 100%;
            font-size: 16px;
            color: rgba(255, 255, 255, 1);
            border: none;
            border-radius: 2px;
            font-weight: 400;
            line-height: 48px;
            margin: 20px 0 80px;
            padding: 0;
            cursor: pointer;
            outline: none;
        }
        .successColor1 {
            background-color: #ffae01;
        }
    }

</style>
